export const postMessageToParent = (data: any) => {
    window.parent.postMessage(data, '*');
};
